const state = {
  colorScheme: 'dark'
}

const getters = {

}

const actions = {
  changeScheme ({ commit }) {
    commit('SET_scheme')
  }
}

const mutations = {
  SET_scheme (state) {
    state.colorScheme = state.colorScheme === 'light' ? 'dark' : 'light'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/layout.js